import { Navigate, Outlet, useLocation } from "react-router-dom";
import { PageRoutes } from "../constants/historyGaming";
import { useAppSelector } from "../components/hooks";
import { selectIsAuthenticated } from "@onmo/auth";

const OnboardingLayout: React.FC = () => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const at = (p: string) => location.pathname.startsWith(p);
  const hasOnboarded = localStorage.getItem("hasOnboarded") === "true";

  if (!hasOnboarded && !at(PageRoutes.Onboarding) && !isAuthenticated) {
    return <Navigate to={PageRoutes.Onboarding} replace />;
  }

  if (hasOnboarded && !at(PageRoutes.Guest) && !isAuthenticated)
    return <Navigate to={PageRoutes.Guest} replace />;

  return <Outlet />;
};

export default OnboardingLayout;
